<template>
    <v-card
            color="white"
            min-width="267"
            v-bind="$attrs"
            v-on="$listeners"
            class="mb-2 mb-sm-0"
    >
        <v-img
                :src="thumburl + video.thumb"
                class="videotile"
                aspect-ratio="1.67"
        >
            <div class="hovermenu" v-if="dev">
                <v-btn icon small @click.stop="OpenMenu()"><v-icon class="white--text">mdi-dots-vertical</v-icon></v-btn>
                <div @click.stop="OpenMenu()" text small class="videomenu white--text">
                    <v-icon class="white--text">mdi-chart-areaspline</v-icon>
                    <span class="white--text pl-1">Breakdown</span>
                </div>
            </div>
            <v-chip
                    v-if="video.new"
                    class="ma-2"
                    color="white"
                    small
            >
                <v-icon left color="success">
                    mdi-octagram
                </v-icon>
                <span class="success--text">New</span>
            </v-chip>
            <div class="vtimeblock" v-if="video.duration">
                {{ video.duration | moment('mm:ss') }}
            </div>
        </v-img>
        <v-card-text class="py-1" style="height:66px;overflow: hidden;">
            <h4>
                {{video.name}}
            </h4>
            <div style="width:100%; font-size: x-small;">
                {{video.description}}
            </div>
        </v-card-text>
        <v-card-actions>
            <span class="caption" v-if="!video.views">no views</span>
            <span class="caption" v-if="video.views>1">{{video.views}} views</span>
            <span class="caption" v-if="video.views===1">{{video.views}} view</span>
            <div class="px-1"> &#8226 </div>
            <span style="font-size: small" v-if="video.createdat">
                                        {{ video.createdat | moment("from", "now") }}
                                    </span>
            <span style="font-size: small" v-else-if="video.createdAt">
                                        {{ video.createdAt | moment("from", "now") }}
                                    </span>
            <v-spacer />
            <v-icon small v-if="video.sharedwithkey && video.ownerkey!==video.sharedwithkey">{{icons.share}}</v-icon>
        </v-card-actions>
    </v-card>
</template>

<script>
  import {
    mapState,
    mapActions
  } from 'vuex'

  export default {
    props:['video'],
    name: "VideoCard",
    components: {},
    data() {
      return {
        thumburl: 'https://videos.athleteforlife.org/',
        videourl: 'https://videos.athleteforlife.org/',
        imgurl: 'https://s3-us-west-2.amazonaws.com/imgforlife/',
      }
    },
    computed: {
      ...mapState(['icons','dev'])
    },
    methods:{
      OpenMenu(){
        console.log('OPEN')
      }
    }
  }

</script>

<style scoped>

    .hovermenu {
        position: absolute;
        top:10px;
        right:10px;
        background-color: black;
        color: white;
        visibility: hidden;
        border-radius: 3px;
    }
    .videotile:hover .hovermenu{
        visibility: inherit;
    }
    .videomenu{
        padding-left:2px;
        height:28px;
        line-height: 28px;
        vertical-align: center;
        width:1px;
        background-color: black;
        right:20px;
        position: absolute;
        top:0;
        z-index: 5;
        text-align: left;
        visibility: hidden;
        transition: all .3s ease-out;
        overflow: hidden;
        display: inline-block;
        text-wrap: none;
        border-radius: 3px;
    }
    .hovermenu:hover .videomenu{
        visibility: inherit;
        width:120px;
    }
    .videomenu:hover{
        background-color: #333333;
    }
    .vtimeblock{
        display: inline;
        padding:3px;
        background-color: black;
        color:white;
        font-weight: bold;
        font-size:.7em;
        position: absolute;
        bottom: 4px;
        right:4px;
    }
    .vtimeblocklist{
        display: inline;
        padding:3px;
        background-color: black;
        color:white;
        font-weight: bold;
        font-size:.7em;
    }
</style>